module.exports = __webpack_public_path__ + "media/images/clock_small-4f996db897d78232db78b8a787415dd4.svg";